import { nextTick,defineComponent, ref, provide, reactive, toRefs, getCurrentInstance, onMounted, onBeforeUnmount, onBeforeUpdate } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import PageLoading from '@/components/common/PageLoading.vue';
import HeaderVR from '@/components/layout/header_vr.vue';
import Footer from '@/components/layout/footer.vue';
import Menu from '@/components/layout/menu.vue';
import Swiper from '@/components/layout/Swiper.vue';
import bus from 'vue3-eventbus'
import SideComponent from '@/components/common/SideComponent.vue';
import Loading from '@/components/common/Loading.vue';
import { wexinShare } from '@/utils/wxshare.js';
// import LivePlayer from '@liveqing/liveplayer-v3';
// import LivePlayerDemo from '@/components/LivePlayerDemo.vue'
// import VideoPlayer from '@/components/VideoPlayerCom.vue';
// import HlsPlayer2 from '@/components/HlsPlayer2.vue';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
// 如果需要播放HLS，在现代浏览器中通常已支持，但为了兼容性可能仍需引入hls.js
import Hls from 'hls.js';
import { getDeviceType } from '@/utils/device.js'

export default defineComponent({
	components: {
		HeaderVR,
		Menu,
	    Footer,
	    PageLoading,
	    Swiper,
	    SideComponent,
	    // LivePlayer,
	    // LivePlayerDemo,
	    // VideoPlayer,
	    // HlsPlayer2,

	},
	props: {

	},
	setup() {
		provide('logoColor', 'black');
		let {ctx, proxy} = getCurrentInstance();
		console.log(proxy,"proxy");
		const router = useRouter();
	    const route = useRoute();
	    const id = route.query.id;
	    const type = route.query.type;
		const data = reactive({
			isMobile: false,
			isLoading:true,
			showHeader: true,
			loginStyle: "min-width:141px;",
			mobileIconStyle: "color:rgba(223, 58, 8, 1);",
			showListIcon: true,			
          	showHeader:false,
			live_poster:'',
			live_poster_mobile:'',
			live_title:'',
          	playerOptions: {
		        autoplay: true,
		        controls: true,
		        techOrder: ['html5', 'flash'],
		        sources: [{
		          type: 'rtmp/flv',
		          src: 'rtmp://liteavapp.qcloud.com/live/liteavdemoplayerstreamid'
		        }]
		    },
		    ws: null,
		    videoOptions: {
                controls: true,//开启交互，即是用户可控。
                muted: false,//开启视频时是否静音
                fluid: true,//根据外层css样式大小，自动填充宽高！比较实用，可搭配响应式
                reload: "metadata",//重载
                //其余设置根据需求添加！
                poster: '',//视频封面
                sources: [],
                techOrder: ['html5','flash'],//
                bufferTime: 7, // 单位：秒，建议5-10秒平衡卡顿与延迟
                // html5: {
                //     hlsjsConfig: {
                //         enableWorker: true,
                //         enableSoftwareAES: true
                //     }
                // },
                html5: {
                    hls: {
                      enableLowInitialPlaylist: false, // 关闭初始低画质锁定
                      overrideNative: true            // 强制使用Video.js的HLS处理逻辑
                    }
                },
                hls: {
                    overrideNative: true
                },
                
            },
			isMuted: true,
			showControls: false,
			shouldAutoPlay: true,
		});
		
		const showMenus = ref(proxy.$menus);
		provide('showMenu', showMenus);
		provide('menuTextStyle', {color:'#fff'});
		provide('showHeader',false);
		
		data.id = id;
		console.log(data.id,'id');
		// data.type = type;

		const getImageUrl = (name) => {
		    return proxy.$utils.getImageUrl(name);
		};

		const store = useStore();
		const getTaleDetail = (id=0) => {
			
		}
		const wxshare = (share_data) => {
			const protocol = window.location.protocol; // 协议 (e.g., "https:")
			const hostname = window.location.hostname; // 域名 (e.g., "example.com")
			let url = protocol+'//'+hostname;
			if(hostname.indexOf("www") == -1){
				url = protocol+'//www.'+hostname;
			}
			url = url+route.fullPath;
			store.dispatch("common/Jssdk",{
				url:url
			}).then((res) => {
				// console.log(res,'jssdk');
				//微信加签              
                // var shareWxLink = encodeURIComponent(url);加密
                let shareData = {
                    title: share_data.title, // 分享标题
                    desc:'',
                    link: url,
                    imgUrl: store.state.common.siteInfo.logo // 分享图标
                };
                //引用
                wexinShare(res, shareData);
	        })
		}
		
		const viewBox = ref(null);
        const scroll = (val) => {
			if(val == 'top'){
				
				viewBox.value.scrollIntoView({
			        behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
			        block: "start", // 定义垂直滚动方向的对齐 start顶部（尽可能）  center中间（尽可能）  end（底部）
			        inline: "center", // 定义水平滚动方向的对齐
			    });
		       
			}else if(val == 'bottom'){
				
				viewBox.value.scrollIntoView({
			        behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
			        block: "end", // 定义垂直滚动方向的对齐 start顶部（尽可能）  center中间（尽可能）  end（底部）
			        inline: "center", // 定义水平滚动方向的对齐
			    });
    
			}
		}
		
	    // Make sure to reset the refs before each update.
	    onBeforeUpdate(() => {
	    	
	    });
	    onBeforeUnmount(()=>{
	    	
	    })
	    
	    onMounted(async()=>{
        	let timer = setTimeout(() => {
		        data.isLoading = false;
			    viewBox.value.scrollIntoView({
			        behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
			        block: "start", // 定义垂直滚动方向的对齐 start顶部（尽可能）  center中间（尽可能）  end（底部）
			        inline: "center", // 定义水平滚动方向的对齐
			    });
		      clearTimeout(timer);
		    }, 500);
		    console.log("页面数据更新完毕了")
        })

		const openVoice = () => {
			console.log('openVoice')
			data.isMuted = false;
			console.log('openVoice',data.isMuted)
		}
		const closeVoice = () => {
			console.log('closeVoice')
			data.isMuted = true;
			console.log('closeVoice',data.isMuted)
		}

		const refData = toRefs(data);

		return {
			...refData,
			getImageUrl,
			viewBox,
			scroll,
			getTaleDetail,
			wxshare,
			openVoice,
			closeVoice,
		}
	},
	created() {

	},
	mounted() {
		this.$nextTick(() => {
			this.live_title = this.$store.state.common.siteInfo.live_title;
			this.live_poster = this.$store.state.common.siteInfo.live_poster;
			this.live_poster_mobile = this.$store.state.common.siteInfo.live_poster_mobile;

			if(getDeviceType() == 'mobile'){
				this.live_poster = this.live_poster_mobile || this.live_poster;
			}
			// this.init();
			this.initPlayer();
		});
	},
	methods: {
		init() {
			console.log(window.location.host,'host');
			// this.ws = new WebSocket('ws://'+window.location.host+'/socket');
			this.ws = new WebSocket('ws://127.0.0.1:8085');
			this.wsStatus = '连接中...';

		    this.ws.onopen = () => {
		        console.log('WebSocket connected');
		        this.wsStatus = '已连接';
		        // 可以发送一条消息告知服务器前端已就绪，或者只是等待服务器推送
		        // this.ws.send(JSON.stringify({ 
		        // 	command: 'start',
          //       	rtmpUrl: rtmpUrl
		        // }));
		    };

		    this.ws.onmessage = (event) => {
		        const message = JSON.parse(event.data);
		        console.log('Message from server:', message);

		        // if (message.type === 'hls_ready') {
		        //   this.transcodeStatus = 'HLS转换完成';
		        //   this.hlsUrl = message.data.hlsUrl; // 例如: http://localhost:8000/live/your_stream_name/index.m3u8
		        //   this.initPlayer(this.hlsUrl); // 收到URL后初始化或更新播放器
		        // } else if (message.type === 'message') {
		        //   this.transcodeStatus = message.data;
		        // }
		    };

		    this.ws.onerror = (error) => {
		        console.error('WebSocket error:', error);
		        this.wsStatus = '连接错误';
		    };

		    this.ws.onclose = () => {
		        console.log('WebSocket closed');
		        this.wsStatus = '连接关闭';
		    };
		},
		initPlayer() {
			// const url = "http://127.0.0.1:3000/output.m3u8";
			const url = "/hls/output.m3u8?t="+Date.now();//"/rtmphls/output/output.m3u8";//"http://"+window.location.host+"/rtmphls/output/output.m3u8";
			if (this.$refs.videoPlayer) {
		        // this.$refs.videoPlayer.dispose(); // 先销毁旧的播放器实例
		    }
			
			console.log(this.$refs.videoPlayer,'this.$refs.videoPlayer')
		    // 使用Hls.js (用于播放HLS流)
		    if (Hls.isSupported()) {
		        const hls = new Hls();
		        hls.loadSource(url);
		        hls.attachMedia(this.$refs.videoPlayer);
		        hls.on(Hls.Events.MANIFEST_PARSED, () => {
		          this.$refs.videoPlayer.play().then(()=>{
		          	// this.isMuted = false;
		          }).catch(e => {
		            console.log('Autoplay prevented:', e);
		          });
		        });
		        // 你也可以将hls实例挂载到this上以便后续控制
		        // this.hls = hls;
		    } 
		    // 如果浏览器原生支持HLS (如Safari)
		    else if (this.$refs.videoPlayer.canPlayType('application/vnd.apple.mpegurl')) {
		        this.$refs.videoPlayer.src = url;
		        this.$refs.videoPlayer.addEventListener('loadedmetadata', () => {
		          this.$refs.videoPlayer.play().then(()=>{
					// this.isMuted = false;
		          	// this.startConversion();
		          }).catch(e => {
		            console.log('Autoplay prevented:', e);
		          });
		        });
		    } else {
		        console.error('HLS is not supported in this browser.');
		        this.transcodeStatus = '浏览器不支持HLS播放';
		    }
			bus.emit('showFooter',true);
		},
		startConversion() {
            // const rtmpUrl = this.$store.state.common.siteInfo.rtmp;
			const rtmpUrl = 'rtmp://liteavapp.qcloud.com/live/liteavdemoplayerstreamid';
            if (!rtmpUrl) {
                alert('请输入RTMP URL');
                return;
            }
            
            this.ws.send(JSON.stringify({
                command: 'start',
                rtmpUrl: rtmpUrl
            }));
			this.$refs.videoPlayer.play().then(()=>{
				// this.isMuted = false;
				// this.startConversion();
			}).catch(e => {
			console.log('Autoplay prevented:', e);
			});
        },
		stopConversion() {
            this.ws.send(JSON.stringify({
                command: 'stop'
            }));
			this.$refs.videoPlayer.pause()
        },
		
		
	},
	beforeUnmount() {
        if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer?.pause()
        }
    },
	beforeDestroy() {
	    if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer?.pause()
        }
	},
})